export default {
  noDataDescription: 'Nie znaleziono danych dla wybranych czujników i przedziałów czasowych',
};
